import { useEffect, useRef, useState, type ReactNode } from 'react';

interface LazyComponentProps {
  children: ReactNode;
  className?: string;
}
export const LazyComponent = ({ children, className }: LazyComponentProps) => {
  const [hasBeenVisible, setHasBeenVisible] = useState(false);
  const componentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (entry && entry.isIntersecting) {
        setHasBeenVisible(true);
      }
    });
    const component = componentRef.current;

    if (component) {
      observer.observe(component);
    }

    // Clean up the observer when component is unmounted
    return () => {
      if (component) {
        observer.unobserve(component);
      }
    };
  }, []);

  return (
    <div ref={componentRef} className={className}>
      {hasBeenVisible && children}
    </div>
  );
};
